import TimeUtils from '@shared/utils/time.utils';
import {
  iconsMap,
  RouteColors,
  RouteNetworkMaintainerIconName,
  RouteNetworkMaintainerType,
} from '@pages/route-network-page/constants';

export default class RouteNetworkColorUtils {
  static getRouteColor(lastMaintainedUtc?: string): string {
    if (!lastMaintainedUtc) {
      return RouteColors.MoreThan30D;
    }

    const lastDate = TimeUtils.parseUTC(lastMaintainedUtc);
    const last = lastDate.getTime();
    const now = Date.now();

    if (isNaN(last)) {
      return RouteColors.MoreThan30D;
    }

    const diffMs = now - last;
    const diffHours = diffMs / (1000 * 60 * 60);
    const diffDays = diffHours / 24;

    if (diffHours < 3) return RouteColors.UpTo3H;
    if (diffHours < 6) return RouteColors.Between3And6H;
    if (diffHours < 18) return RouteColors.Between6And18H;
    if (diffHours < 48) return RouteColors.Between18And48H;

    if (diffDays < 7) return RouteColors.Between2And7D;
    if (diffDays < 15) return RouteColors.Between7And15D;
    if (diffDays < 30) return RouteColors.Between15And30D;

    return RouteColors.MoreThan30D;
  }

  static getIconWithFill(iconName: string, color: string): string {
    const svg = iconsMap[iconName] ?? iconsMap['icon-info'];
    const withFill = svg.replace(/fill="[^"]*"/g, `fill="${color}"`);

    return `<div class="poi-marker">${withFill}</div>`;
  }

  static getRouteMaintainerColorAndIconUrl(
    routeMaintainerType: RouteNetworkMaintainerType | undefined,
    lastActivityTimeUtc?: string
  ): {
    color: string;
    iconUrl: string;
  } {
    const iconName =
      RouteNetworkMaintainerIconName[
        routeMaintainerType || RouteNetworkMaintainerType.TrailGroomer
      ];
    if (!lastActivityTimeUtc) {
      return {
        color: RouteColors.MoreThan30D,
        iconUrl: `./assets/cars/${iconName}_sleep.svg`,
      };
    }

    const lastDate = TimeUtils.parseUTC(lastActivityTimeUtc);
    const last = lastDate.getTime();
    const now = Date.now();

    if (isNaN(last)) {
      return {
        color: RouteColors.MoreThan30D,
        iconUrl: `./assets/cars/${iconName}_sleep.svg`,
      };
    }

    const diffMins = (now - last) / (1000 * 60);

    if (diffMins <= 15) {
      return {
        color: RouteColors.Between3And6H,
        iconUrl: `./assets/cars/${iconName}_active.svg`,
      };
    }

    if (diffMins > 15 && diffMins <= 60) {
      return {
        color: RouteColors.Between7And15D,
        iconUrl: `./assets/cars/${iconName}_standby.svg`,
      };
    }

    return {
      color: RouteColors.MoreThan30D,
      iconUrl: `./assets/cars/${iconName}_sleep.svg`,
    };
  }
}
